import { render, staticRenderFns } from "./UsersUtillsModal.vue?vue&type=template&id=489da925&"
import script from "./UsersUtillsModal.vue?vue&type=script&lang=js&"
export * from "./UsersUtillsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports